import _helpers from '../globals/_helpers'
import { sendTrackEvent } from './trackEvent'

function getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
  if (typeof window === 'undefined') return 'desktop'
  if (window.innerWidth < 768) return 'mobile'
  if (window.innerWidth < 1024) return 'tablet'
  return 'desktop'
}

function getCurrentUrl(): string {
  return typeof window !== 'undefined' ? window.location.href : ''
}

function getCountry(): string {
  return _helpers.getCookie('_userCountryCode') ?? ''
}

export function trackPageViewed(pageType: string): void {
  sendTrackEvent('Page Viewed', {
    url: getCurrentUrl(),
    referrer: typeof document !== 'undefined' ? document.referrer : '',
    page_type: pageType,
    country: getCountry(),
    device_type: getDeviceType()
  })
}

export function trackCtaClicked(
  ctaLabel: string,
  ctaDataEventId: string,
  href: string
): void {
  sendTrackEvent('CTA Clicked', {
    cta_label: ctaLabel,
    cta_data_event_id: ctaDataEventId,
    page_url: href
  })
}

export function trackFormStarted(formName: string): void {
  sendTrackEvent('Form Started', {
    form_name: formName,
    page_url: getCurrentUrl()
  })
}

export function trackFormAbandoned(
  formName: string,
  lastFieldTouched: string
): void {
  sendTrackEvent(
    'Form Abandoned',
    {
      form_name: formName,
      last_field_touched: lastFieldTouched
    },
    { beacon: true }
  )
}

export function trackDemoRequested(formName: string): void {
  sendTrackEvent('Demo Requested', {
    form_name: formName,
    page_url: getCurrentUrl()
  })
}

export function trackMqlConversion(formName: string): void {
  sendTrackEvent('MQL Conversion', {
    form_name: formName,
    page_url: getCurrentUrl()
  })
}

export function trackPricingPageViewed(planViewed: string): void {
  sendTrackEvent('Pricing Page Viewed', {
    plan_viewed: planViewed,
    country: getCountry()
  })
}

export function trackMel(formName: string): void {
  sendTrackEvent('MEL', {
    form_name: formName,
    page_url: getCurrentUrl()
  })
}
